<template>
  <v-icon class="mr-3">mdi-progress-wrench</v-icon>
</template>
